import styled from 'styled-components';

export const Container = styled.div`
  .search-button {
    padding: 0.1rem 0.75rem !important;
    min-width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;

    .material-icons {
      font-size: 1.2rem;
    }

    .spinner-border-sm {
      width: 1rem;
      height: 1rem;
    }
  }

  .input-group {
    .form-control {
      border-right: 0;

      &:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
    }
  }

  .insured-search-result {
    cursor: pointer;
    border-color: #007bff !important;

    &:hover {
      background-color: #e7f3ff !important;
    }
  }
`;
